export default function sliders() {
    let recommendationsSlider = $('.recommendations-slider')
    recommendationsSlider.slick({
        infinite: false,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $('#arrowLeft'),
        nextArrow: $('#arrowRight'),
        swipe: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    arrow: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.3,
                    arrow: false
                }
            },
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 1.5,
                    arrow: false
                }
            },
        ]
    });

    let swatchSlider = $('.swatch-slider')

    swatchSlider.each(function(){
        let productId = $(this).attr('id').split('-').pop().trim()

        if($(this).children().length > 7){
            $(this).on('mousedown', function(){
                recommendationsSlider.slick('slickSetOption', 'swipe', false)
            })

            $(this).not('.slick-initialized').slick({
                slidesToShow: 7,
                slidesToScroll: 1,
                infinite: false,
                centerMode: false,
                dots: false,
                prevArrow: $(this).siblings('.arrowLeft')[0],
                nextArrow: $(this).siblings('.arrowRight')[0]
            }).on('afterChange', function(event, slick){
                recommendationsSlider.slick('slickSetOption', 'swipe', true)
            });
        }
    })

    $('.color-swatch-button').on('click', function(e) {
        $(this).addClass("selected");
        $(this).siblings().removeClass("selected")
        e.preventDefault();
    });
}
